import Rfid from './Rfid'

export default Rfid
